/**
 * Full-module flags.
 *
 * A module can be FINISHED in the code and still not be available to users, because the
 * business decision to offer it hasn't been made yet. This file is the only place that
 * decides that: flip a constant and the module goes in or out, without touching routes,
 * permissions, menus, or endpoints.
 *
 * Both the frontend (routes, side menu, tours) and the backend (`server.ts`) consume it at
 * once, so that "disabled" means the same thing on both sides. Turning it off only in the
 * interface would leave the endpoints open to anyone who knows the URLs.
 */

/**
 * Parcel operations (guides, UPS shipments, daily inbox inside `/operations`).
 *
 * `true` (28/08, explicit user correction): a 27/08 change had disabled this alongside the
 * now-removed Air Freight module, but unlike air freight this is an actively-used workflow, not
 * a "coming soon" feature -- it should never have been hidden from nav.
 */
export const OPERATIONS_MODULE_ENABLED = true;
